var _rect, _rect2, _circle, _g, _text, _text2, _rect3, _text3, _path, _path2, _g2, _g3, _g4, _rect4, _text4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalentlenzApplicantEvidenceJourneyInterface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 760,
    height: 286,
    viewBox: "0 0 760 286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TalentLenz applicant evidence journey interface") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 758,
    height: 284,
    rx: 26,
    fill: "#FFFFFF",
    stroke: "#C8DCF3",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 22,
    width: 712,
    height: 54,
    rx: 15,
    fill: "#F5F9FE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 49,
    r: 15,
    fill: "#FFF0F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#FF3885",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 17,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 20,
    r: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 45c1-9 5-13 12-13s11 4 12 13M58 34c7-1 12 2 14 10"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 46,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 790
  }, "Your application")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 64,
    fill: "#667A94",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "A guided evidence journey")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 608,
    y: 35,
    width: 103,
    height: 28,
    rx: 14,
    fill: "#EAF4FF"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 659.5,
    y: 53,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5,
    fontWeight: 780
  }, "3 OF 3 READY")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 151H380M380 151H630",
    fill: "none",
    stroke: "#C6D9EE",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130 151H630",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 3,
    strokeDasharray: "0 500"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 151,
    r: 34,
    fill: "#EAF4FF",
    stroke: "#87C6FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 141,
    r: 8,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 168c1-11 6-16 16-16s15 5 16 16",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 128,
    r: 9,
    fill: "#087CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146 128 3 3 5-6",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 208,
    textAnchor: "middle",
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 760
  }, "Profile"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 228,
    textAnchor: "middle",
    fill: "#667A94",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "Details captured"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 151,
    r: 34,
    fill: "#FFF0F6",
    stroke: "#F4B1CA",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 133,
    width: 26,
    height: 34,
    rx: 4,
    fill: "none",
    stroke: "#FF3885",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 143h14M373 150h14M373 157h9",
    stroke: "#FF3885",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 128,
    r: 9,
    fill: "#FF3885"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396 128 3 3 5-6",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 380,
    y: 208,
    textAnchor: "middle",
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 760
  }, "Evidence"), /*#__PURE__*/React.createElement("text", {
    x: 380,
    y: 228,
    textAnchor: "middle",
    fill: "#667A94",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "CV \xB7 ID \xB7 Qualification"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 630,
    cy: 151,
    r: 34,
    fill: "#EAF4FF",
    stroke: "#87C6FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616,
    y: 136,
    width: 28,
    height: 28,
    rx: 5,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m622 150 5 5 10-12",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 128,
    r: 9,
    fill: "#087CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m646 128 3 3 5-6",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 208,
    textAnchor: "middle",
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 760
  }, "Assessment"), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 228,
    textAnchor: "middle",
    fill: "#667A94",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "Completed in control"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 248,
    width: 266,
    height: 22,
    rx: 11,
    fill: "#07152A"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 380,
    y: 263,
    textAnchor: "middle",
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5,
    fontWeight: 750
  }, "APPLICATION EVIDENCE READY FOR REVIEW")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentlenzApplicantEvidenceJourneyInterface);
export default __webpack_public_path__ + "static/media/talentlenz-applicant-evidence-journey-interface.28d199cab463320c7c2ee524dbd784d4.svg";
export { ForwardRef as ReactComponent };